import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.menuBackground};

  @media (max-width: 900px) {
    height: 100%;
  }

  @media (max-width: 900px) and (min-height: 925px) {
    height: 100vh;
  }

  @media (max-width: 550px) and (min-height: 884px) {
    height: 100vh;
  }

  @media (min-width: 550px) and (max-height: 656px) {
    height: 100%;
  }
`;

export const Content = styled.section`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.menuHover};

  @media (max-width: 900px) {
    padding: 30px 0;
  }

  main,
  aside {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: auto;
    align-items: center;
    justify-content: center;

    h1,
    a {
      font-weight: bold;
      font-size: 1.4rem;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: ${({ theme }) => theme.text};

      @media (max-height: 700px) {
        margin-bottom: -5px;
      }

      @media (max-width: 900px) {
        margin-bottom: 5px;
      }
    }

    section {
      width: 60%;
      text-align: start;

      div {
        margin-top: -7px;

        @media (max-height: 700px) {
          margin-top: -10px;
        }

        @media (max-height: 700px) and (max-width: 900px) {
          margin-top: -7px;
        }

        :last-child {
          margin-top: -10px;

          @media (max-height: 700px) {
            margin-top: -14px;
          }

          @media (max-height: 700px) and (max-width: 900px) {
            margin-top: -10px;
          }
        }
      }

      @media (max-width: 500px) {
        width: 80%;
      }
    }

    p,
    span {
      text-align: start;
      font-size: 1rem;
      margin-bottom: -1px;
      text-transform: uppercase;
      letter-spacing: 2px;
    }

    span {
      font-weight: bold;
      cursor: pointer;
      margin-left: 5px;

      :hover {
        text-decoration: underline;
      }
    }

    form {
      button {
        border: none;
        background-color: ${({ theme }) => theme.purple};
        height: 60px;
        width: 100%;
        box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.25);

        color: ${({ theme }) => theme.white};
        font-size: 1.3rem;
        letter-spacing: 2px;
        text-transform: uppercase;

        :hover {
          filter: brightness(1.2);
          transition: 0.3s;
        }
      }
    }

    img {
      width: 60%;
    }
  }

  aside {
    height: 100%;
  }

  @media (max-width: 1050px) {
    main {
      flex: 6;
    }

    aside {
      flex: 4;

      img {
        width: 70%;
      }
    }
  }

  @media (max-width: 900px) {
    main {
      flex: 7;
    }

    aside {
      flex: 3;

      img {
        width: 100%;
      }
    }
  }

  @media (max-width: 1050px) {
    aside {
      display: none;
    }
  }
`;

export const LoginOptions = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.25);

  @media (max-height: 700px) {
    margin-bottom: 8px;
  }

  @media (max-width: 900px) {
    margin-bottom: 20px;
  }

  button {
    background-color: ${({ theme }) => theme.white};
    width: 100%;

    h1 {
      display: flex;
      margin: auto;
      justify-content: center;
      padding: 10px 0;
      color: ${({ theme }) => theme.purple};

      @media (max-height: 700px) {
        padding: 7px 0;
      }

      @media (max-width: 900px) {
        padding: 10px 0;
      }
    }

    h1.spinner {
      animation: spin 1s infinite;

      @-moz-keyframes spin {
        100% {
          -moz-transform: rotate(360deg);
        }
      }
      @-webkit-keyframes spin {
        100% {
          -webkit-transform: rotate(360deg);
        }
      }
      @keyframes spin {
        100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
    }

    :hover {
      background-color: ${({ theme }) => theme.purple};
      filter: brightness(1.3);
      transition: 0.7s ease;
      h1 {
        color: ${({ theme }) => theme.white};
      }
    }
  }
`;

export const FormWrapper = styled.div`
  width: 60%;
  background-color: ${({ theme }) => theme.white};
  box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.25);
  text-align: start;
  margin-bottom: 10px;

  @media (max-height: 700px) {
    margin-bottom: 3px;
  }

  @media (max-width: 900px) {
    margin-bottom: 10px;
  }

  @media (max-width: 500px) {
    width: 80%;
  }

  div {
    padding: 0px 6px 0;
  }

  label {
    display: block;
    padding-top: 15px;
    letter-spacing: 0.1rem;
    font-weight: bold;
    font-size: 1.1rem;
    color: ${({ theme }) => theme.black};
    margin-left: 15px;
    text-transform: uppercase;
  }
`;
